import { render } from "./News_index_en.vue?vue&type=template&id=7ce2d687&scoped=true"
import script from "./News_index_en.vue?vue&type=script&lang=js"
export * from "./News_index_en.vue?vue&type=script&lang=js"

import "./News_index_en.vue?vue&type=style&index=0&id=7ce2d687&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ce2d687"

export default script